import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import Ad from '@ifeng/ui_pc_ad';
import LogoLine from './logoLine/';

/**
 * 定义 Header 组件
 */
class Header extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { ad_top_banner, logo, search },
        } = this.props;

        return (
            <Fragment>
                <Ad content={ad_top_banner} styleName={styles.ad} />
                <LogoLine content={{ logo, search }} />
            </Fragment>
        );
    }
}

export default errorBoundary(Header);
